// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24.0029 12.0001L0.291992 1.66455L3.58686 11H11.0005V13H3.5869L0.291992 22.3356L12.8617 16.8565C13.7475 14.3198 16.1612 12.5 19 12.5C19.9274 12.5 20.8094 12.6942 21.6076 13.0442L24.0029 12.0001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.8308 14.7573L19.0024 17.5858L16.174 14.7573L14.7598 16.1715L17.5882 19L14.7598 21.8284L16.174 23.2426L19.0024 20.4142L21.8308 23.2426L23.245 21.8284L20.4166 19L23.245 16.1715L21.8308 14.7573Z"}}]};

const SendCancelFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send-cancel-filled',
    ref,
    icon: element,
  },
));

SendCancelFilledIcon.displayName = 'SendCancelFilledIcon';

export default SendCancelFilledIcon;
